import { Report } from '../generated'

export default (statusReport: Report['statusReport']) => `${statusReport}`
